var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-wrap", staticStyle: { padding: "20px" } },
    [
      _c(
        "div",
        { staticClass: "form-layout" },
        [
          _c(
            "el-form",
            {
              ref: "checkItemInfo",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.checkItem,
                rules: _vm.checkItemCheck,
                "label-width": "100px"
              }
            },
            [
              _c("div", { staticClass: "form-info" }, [
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("项目内容")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-3x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "content" } },
                        [
                          _c("el-input", {
                            staticClass: "width-2x",
                            model: {
                              value: _vm.checkItem.content,
                              callback: function($$v) {
                                _vm.$set(_vm.checkItem, "content", $$v)
                              },
                              expression: "checkItem.content"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-red" }, [
                            _vm._v("注:最大长度为60个字符")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("基本要求")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-3x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "demand" } },
                        [
                          _c("el-input", {
                            staticClass: "width-2x",
                            model: {
                              value: _vm.checkItem.demand,
                              callback: function($$v) {
                                _vm.$set(_vm.checkItem, "demand", $$v)
                              },
                              expression: "checkItem.demand"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-red" }, [
                            _vm._v("注:最大长度为90个字符")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("参考标准")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-3x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "standard" } },
                        [
                          _c("el-input", {
                            staticClass: "width-2x",
                            model: {
                              value: _vm.checkItem.standard,
                              callback: function($$v) {
                                _vm.$set(_vm.checkItem, "standard", $$v)
                              },
                              expression: "checkItem.standard"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-red" }, [
                            _vm._v("注:最大长度为30个字符")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row", staticStyle: { height: "80px" } },
                  [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("适用分类")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-3x" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "appliedCatNames" } },
                          [
                            _c("el-input", {
                              staticClass: "width-2x",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.checkItem.appliedCatNames,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkItem,
                                    "appliedCatNames",
                                    $$v
                                  )
                                },
                                expression: "checkItem.appliedCatNames"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.selectCatName()
                                  }
                                }
                              },
                              [_vm._v("快捷输入")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ca3dbd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ca3dbd6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/rentServc/DevcMaintCheckItemSave.vue
// module id = 1996
// module chunks = 1